import { useNavigate } from "react-router-dom";
import { ArrowRight, Heart } from "lucide-react";
import { Button } from "../ui/button";

export const DatingAgencySection = () => {
  const navigate = useNavigate();

  return (
    <section id="dating-agency" className="pt-6 pb-10 lg:pt-8 lg:pb-14 bg-gradient-to-br from-violet-100 via-rose-50 to-amber-50 relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-[700px] h-[700px] bg-gradient-to-bl from-violet-300/50 to-purple-200/30 rounded-full blur-3xl translate-x-1/4 -translate-y-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-gradient-to-tr from-amber-300/50 to-yellow-200/30 rounded-full blur-3xl -translate-x-1/4 translate-y-1/4"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-10">
          <span className="text-gold-500 font-medium text-sm tracking-wider uppercase mb-2 block">
            Trusted Member Network
          </span>
          <h2 className="font-sans text-3xl md:text-4xl font-[720] text-stone-800 mb-2">
            리즈 연애정보회사
          </h2>
          <p className="text-stone-500 text-lg md:text-xl tracking-wide mb-6">
            1:1 맞춤소개팅
          </p>
          
          {/* Main Quote - Bold */}
          <p className="font-sans text-xl md:text-2xl lg:text-3xl font-[720] text-burgundy-700 mb-2">
            "완벽한 인생을 위한 마지막 퍼즐 한 조각"
          </p>
          <p className="text-stone-500 text-base md:text-lg italic mb-6">
            The Final Piece to Your Perfect Life.
          </p>
          
          {/* Description Text */}
          <div className="max-w-4xl mx-auto text-stone-600 text-base md:text-lg leading-relaxed space-y-4">
            <p>
              어쩌면 당신의 일상은 이미 충분히 아름답습니다.<br className="hidden md:block" />
              하지만 누군가와 함께 그 일상을 공유할 때, 비로소 세상의 색채는 더욱 선명해지죠.
            </p>
            <p>
              혼자서도 잘 해온 당신이지만, 마음 한구석 비워두었던 그 자리를 따뜻한 온기로 채워보세요.<br className="hidden md:block" />
              리즈는 단순히 사람을 연결하는 것을 넘어, 당신의 삶이 가장 찬란하게 빛날 그 순간을 디자인합니다.
            </p>
            <p className="text-burgundy-600 font-medium">
              당신의 계절에 가장 어울리는 사랑, 이제 곧 시작됩니다.
            </p>
          </div>
        </div>

        {/* Image Card - Full Width */}
        <div 
          className="w-full rounded-3xl overflow-hidden shadow-2xl cursor-pointer group transition-all duration-500 hover:shadow-3xl hover:-translate-y-2"
          onClick={() => navigate('/dating-agency')}
        >
          {/* Image Container */}
          <div className="relative h-[350px] md:h-[450px] lg:h-[500px] overflow-hidden">
            <img 
              src="/images/dating-agency-bg.png" 
              alt="리즈 연애정보회사"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            {/* Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
            
            {/* Content Overlay */}
            <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-10 lg:p-12">
              {/* Badge */}
              <div className="flex items-center gap-2 mb-4">
                <span className="px-3 py-1 bg-gold-400 text-stone-800 text-xs font-bold rounded-full">
                  PREMIUM
                </span>
                <span className="px-3 py-1 bg-white/20 backdrop-blur-sm text-white text-xs font-medium rounded-full">
                  1:1 맞춤 매칭
                </span>
              </div>
              
              {/* Title */}
              <h3 className="font-sans text-2xl md:text-3xl lg:text-4xl font-[720] text-white mb-3">
                당신의 인연을 찾아드립니다
              </h3>
              
              {/* Features */}
              <div className="flex flex-wrap gap-3 md:gap-4 mb-6">
                <div className="flex items-center gap-2 text-white/90">
                  <Heart className="w-4 h-4 text-rose-400" />
                  <span className="text-sm">맞춤 소개팅</span>
                </div>
                <div className="flex items-center gap-2 text-white/90">
                  <Heart className="w-4 h-4 text-rose-400" />
                  <span className="text-sm">전문 매니저 상담</span>
                </div>
                <div className="flex items-center gap-2 text-white/90">
                  <Heart className="w-4 h-4 text-rose-400" />
                  <span className="text-sm">연애 코칭</span>
                </div>
              </div>
              
              {/* CTA Button */}
              <Button 
                size="lg"
                className="w-fit bg-white hover:bg-white/90 text-stone-800 font-semibold group/btn"
              >
                자세히 알아보기
                <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover/btn:translate-x-1" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
